import { render, staticRenderFns } from "./MakeMask.vue?vue&type=template&id=f31fe706&scoped=true&"
import script from "./MakeMask.vue?vue&type=script&lang=js&"
export * from "./MakeMask.vue?vue&type=script&lang=js&"
import style0 from "./MakeMask.vue?vue&type=style&index=0&id=f31fe706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31fe706",
  null
  
)

export default component.exports